module.exports = __webpack_public_path__ + "img/title2.44cddc09.png";